import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse,
    HttpErrorResponse,
} from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
    constructor(public auth: AuthService) {}

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (this.auth.getActiveApothekenBestellung()) {
            request = request.clone({
                setHeaders: {
                    Authorization:
                        'Basic ' +
                        btoa(
                            this.auth.apothekenUsername +
                                ':' +
                                this.auth.apothekenPassword
                        ),
                },
            });
            this.auth.clearApothekenAnfrage();
        } else {
            const currentUser = this.auth.currentUserValue;
            if (this.auth.getActiveLoginAttempt()) {
                request = request.clone({
                    setHeaders: {
                        Authorization: this.auth.getActiveLoginAttempt()
                            .password,
                    },
                });
                this.auth.clearActiveLoginAttempt();
            } else {
                if (currentUser) {
                  request = request.clone({
                      setHeaders: {
                          Authorization: currentUser.token,
                      },
                  });
                }
            }
        }

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                return event;
            })
        );
    }
}
